export enum CarryoverCheckStatus {
  Passed = 0,
  Failed = 1,
  Warning = 2,
}
